import global from "@/locales/nn-NO/global";
import loginPageSteps from "@/locales/nn-NO/loginPageSteps";
import error403 from "@/locales/nn-NO/errors/403";
import error404 from "@/locales/nn-NO/errors/404";
import error500 from "@/locales/nn-NO/errors/500";
import error503 from "@/locales/nn-NO/errors/503";
import error504 from "@/locales/nn-NO/errors/504";
import maintenance from "@/locales/nn-NO/auth/maintenance";
import onboarding from "@/locales/nn-NO/auth/onboarding";
import login from "@/locales/nn-NO/auth/login";
import account from "@/locales/nn-NO/account/account";
import mailbox from "@/locales/nn-NO/account/mailbox";
import bankstatement from "@/locales/nn-NO/account/bankstatement";
import myApps from "@/locales/nn-NO/my-apps/myApps";
import contactService from "@/locales/nn-NO/about/contactService";
import salesPromotions from "@/locales/nn-NO/sales/promotions";
import brochures from "@/locales/nn-NO/sales/brochures";
import dashboard from "@/locales/nn-NO/dashboard/dashboard";
import staff from "@/locales/nn-NO/dashboard/staff";
import promotions from "@/locales/nn-NO/promotions";
import points from "@/locales/nn-NO/points";
import shop from "@/locales/nn-NO/shop/data";
import priceList from "@/locales/nn-NO/shop/priceList";
import trainings from "@/locales/nn-NO/trainings/trainings";
import vouchers from "@/locales/nn-NO/vouchers/vouchers";
import widgets from "@/locales/nn-NO/widgets/widgets";
import generateReport from "@/locales/nn-NO/generate-report/generateReport";
import wholesaler from "@/locales/nn-NO/wholesaler/wholesaler";
import media from "@/locales/nn-NO/media/index";
import product from "@/locales/nn-NO/product/index";
import message from "@/locales/nn-NO/message/index";
import commitmentLetter from "@/locales/nn-NO/account/commitmentLetter";
import multiplicator from "@/locales/nn-NO/multiplicator";
import toast from "@/locales/nn-NO/toast/toast";
import consents from "@/locales/nn-NO/consents/consents";
import investment from "@/locales/nn-NO/investment/data";
import kickback from "@/locales/nn-NO/kickback";

//prettier-ignore
const messages = {
  loginPageSteps: loginPageSteps.messages,
  global: global.messages,
  error403: error403.messages,
  error404: error404.messages,
  error500: error500.messages,
  error503: error503.messages,
  error504: error504.messages,
  maintenance: maintenance.messages,
  onboarding: onboarding.messages,
  login: login.messages,
  account: account.messages,
  mailbox: mailbox.messages,
  bankstatement: bankstatement.messages,
  myApps: myApps.messages,
  contactService: contactService.messages,
  salesPromotions: salesPromotions.messages,
  shop: shop.messages,
  dashboard: dashboard.messages,
  multiplicator: multiplicator.messages,
  staff: staff.messages,
  promotions: promotions.messages,
  points: points.messages,
  brochures: brochures.messages,
  trainings: trainings.messages,
  vouchers: vouchers.messages,
  generateReport: generateReport.messages,
  widgets: widgets.messages,
  wholesaler: wholesaler.messages,
  media: media.messages,
  priceList: priceList.messages,
  productInfo: product.messages,
  message: message.messages,
  commitmentLetter: commitmentLetter.messages,
  toast: toast.messages,
  consents: consents.messages,
  investment: investment.messages,
  kickback: kickback.messages,
  productBrochures: {
    BDriveTitle: "Produktbilete",
    BDriveLinkText: "Lenkje til PRODUCT IMAGES-portalen",
  },
}

export default {
  locale: "nn-NO",
  messages,
};
